module.exports = __webpack_public_path__ + "img/221122-bimistock-image-11@1x.bd1d4b14.png";